/* eslint no-new: "off" */

import React from 'react'
import Resx from '@/components/Resx'
import {
  FormGroup,
  Label,
  Input,
  Alert
} from 'reactstrap'

export default class RegexInput extends React.Component {
  constructor (props, context) {
    super(props, context)

    this.state = {
      value: props.defaultValue,
      error: ''
    }
  }

  validateRegex (val) {
    try {
      new RegExp(val)
    } catch (e) {
      return false
    }

    return true
  }

  changeRegex (value) {
    if (this.validateRegex(value)) {
      this.setState({
        error: '',
        value: value
      }, () => this.onChange())
    } else {
      this.addError()
    }
  }

  addError () {
    this.setState({
      error: 'Entered regular expression is invalid.'
    })
  }

  onChange () {
    this.props.onChange(this.state.value)
  }

  render () {
    return (
      <FormGroup>
        {this.state.error &&
          <Alert color='danger'>{this.state.error}</Alert>}
        <Label><Resx name='Common.Regex' />:</Label>
        <Input
          onKeyUp={(e) => this.changeRegex(e.target.value)}
          onChange={(e) => this.changeRegex(e.target.value)}
          defaultValue={this.state.value} />
      </FormGroup>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/codeLists/regexInput.js